export const LIST_COURSE_OFFERED_REQ = "LIST_COURSE_OFFERED_REQ";
export const LIST_COURSE_OFFERED_SUCCESS = "LIST_COURSE_OFFERED_SUCCESS";
export const LIST_COURSE_OFFERED_FAILED = "LIST_COURSE_OFFERED_FAILED";
